import 'featherlight';
// eslint-disable-next-line
import FeatherlightGallery  from 'featherlight/src/featherlight.gallery';

export function gallery() {
  let galleryOptions = {};

  initFeatherlightGallery($('.gallery:not(.links) .card-columns'));

  $.featherlightGallery.prototype.afterContent = function () {
      var caption = this.$currentTarget.data('caption');
      this.$instance.find('.caption').remove();

      if (caption) {
        $('<p class="caption">').text(caption).appendTo(this.$instance.find('.featherlight-content'));
      }

      var closeBtn = this.$instance.find('.featherlight-close-icon');
      if (closeBtn.parent().hasClass('close-wrap')) {
        closeBtn.unwrap();
      }
      closeBtn.wrap('<div class="container close-wrap"></div>');
  }

  $('.gallery-big button').click(function () {
    let galleryID = $(this).data('id');

    if(typeof galleryOptions[galleryID] == 'undefined'){
      galleryOptions[galleryID] = {
        'action': 'galleryShowMore',
        'id': galleryID,
        'show': sanacorp.gallery_show_count,
        'offset': sanacorp.gallery_show_count,
      };
    }

    let $this = $(this);
    let galleryList = $('.gallery-'+ galleryOptions[galleryID].id);

    $this.addClass('lds-dual-ring');

    $.ajax({
      type: 'POST',
      url: sanacorp.ajax_url,
      data: galleryOptions[galleryID],
      dataType: 'json',
      success: function(res) {
        galleryList.append(res['content']);
        galleryOptions[galleryID].offset = res['offset'];
        if (res['more'] == 0) $this.removeClass('d-block').css('display', 'none');
        $this.removeClass('lds-dual-ring');

        initFeatherlightGallery(galleryList);
      },
      error: function (request, status, error) {
        console.log(request);
        console.log(status);
        console.log(error);
      },
    });
  });

  $('.gallery-small button').click(function () {
    let galleryID = $(this).data('id');
    let show = $(this).data('show');
    let postID = $(this).data('post-id');

    if(typeof galleryOptions[galleryID] == 'undefined') {
      galleryOptions[galleryID] = {
        'action': 'galleryMultiShowMore',
        'id': galleryID,
        'show': show,
        'offset': show,
        'postID': postID,
      };
    }

    let $this = $(this);
    let galleryList = $('.gallery-'+ galleryOptions[galleryID].id);

    $this.addClass('lds-dual-ring');

    $.ajax({
      type: 'POST',
      url: sanacorp.ajax_url,
      data: galleryOptions[galleryID],
      dataType: 'json',
      success: function(res) {
        galleryList.append(res['content']);
        galleryOptions[galleryID].offset = res['offset'];
        if (res['more'] == 0) $this.removeClass('d-block').css('display', 'none');
        $this.removeClass('lds-dual-ring');

        initFeatherlightGallery(galleryList);
      },
      error: function (request, status, error) {
        console.log(request);
        console.log(status);
        console.log(error);
      },
    });
  });

  function initFeatherlightGallery(galleryList) {
    galleryList.find('a').featherlightGallery({
      type: 'image',
      previousIcon: '',
      nextIcon: '',
      closeIcon: '',
      onResize: function() {
        this.$instance.find('.caption').width(this.$content.width()-30)
      },
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/components/gallery.js